import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { FaLink, FaCopy } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
// --- INICIO DE LA MODIFICACIÓN ---
import { useLanguageLink } from '../../hooks/useLanguageLink';
// --- FIN DE LA MODIFICACIÓN ---

const DashboardHeader = ({ username }) => {
  const { t } = useTranslation();
  // --- INICIO DE LA MODIFICACIÓN ---
  const { langLink } = useLanguageLink();
  // Se construye la URL usando el hook para añadir el prefijo de idioma
  const profileUrl = `${window.location.origin}${langLink(`/u/${username}`)}`;
  // --- FIN DE LA MODIFICACIÓN ---

  const handleCopy = () => {
    navigator.clipboard.writeText(profileUrl);
    toast.success(t('dashboard.header.copy_success_toast'));
  };

  return (
    <header className="mb-6">
      <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-black dark:text-white mb-1">
        {username ? (
          <Trans i18nKey="dashboard.header.welcome" values={{ username }}>
            Welcome, <span className="text-primary">{{ username }}</span>
          </Trans>
        ) : (
          t('dashboard.header.welcome_fallback')
        )}
      </h1>
      <p className="text-gray-500 dark:text-gray-400 text-sm md:text-base mb-3">
        {t('dashboard.header.subtitle')}
      </p>

      <div className="w-full flex flex-col items-start sm:items-center">
        <label className="text-gray-500 dark:text-gray-400 text-xs font-semibold mb-1">
          {t('dashboard.header.profile_link_label')}
        </label>
        <div className="flex items-center bg-gray-50 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-full px-3 py-1 gap-2 w-full max-w-md shadow-sm">
          <FaLink className="text-primary text-lg" />
          <span className="font-mono text-gray-600 dark:text-neutral-300 text-xs md:text-sm break-all select-all">
            {profileUrl}
          </span>
          <button
            onClick={handleCopy}
            type="button"
            className="ml-2 bg-primary hover:bg-primary-dark text-white rounded-full p-2 flex items-center gap-1 shadow transition-colors active:scale-95"
            title={t('dashboard.header.copy_link_tooltip')}
          >
            <FaCopy />
          </button>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
